import { render, staticRenderFns } from "./leaveParty.vue?vue&type=template&id=1bf1e581&scoped=true"
import script from "./leaveParty.vue?vue&type=script&lang=js"
export * from "./leaveParty.vue?vue&type=script&lang=js"
import style0 from "./leaveParty.vue?vue&type=style&index=0&id=1bf1e581&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf1e581",
  null
  
)

export default component.exports